import React, { useEffect, useState } from 'react';
import { AppLayout } from '@/components/layout/AppLayout';
import { AppHeader } from '@/components/layout/AppHeader';
import { Footer } from '@/components/layout/Footer';
import GenerationAnalyticsDashboard from '@/components/analytics/GenerationAnalyticsDashboard';
import { useAuth } from '@/contexts/AuthContext';
import { supabase } from '@/integrations/supabase/client';
import { Navigate, useParams } from 'react-router-dom';

const Analytics: React.FC = () => {
  const { user } = useAuth();
  const [isAdmin, setIsAdmin] = useState<boolean>(false);
  const [loading, setLoading] = useState<boolean>(true);
  const { lang } = useParams<{ lang?: string }>();
  const prefix = `/${lang || 'en'}`;

  useEffect(() => {
    const checkAdminStatus = async () => {
      if (!user) {
        setLoading(false);
        return;
      }

      try {
        const { data: profile } = await supabase
          .from('profiles')
          .select('is_admin')
          .eq('user_id', user.id)
          .single();

        setIsAdmin(profile?.is_admin || false);
      } catch (error) {
        console.error('Error checking admin status:', error);
        setIsAdmin(false);
      } finally {
        setLoading(false);
      }
    };

    checkAdminStatus();
  }, [user]);

  if (loading) {
    return (
      <AppLayout>
        <div className="container mx-auto px-4 py-8">
          <div className="text-center">Loading...</div>
        </div>
      </AppLayout>
    );
  }

if (!user || !isAdmin) {
    return <Navigate to={prefix} replace />;
  }

  return (
    <AppLayout>
      <AppHeader
        title="Analytics Dashboard"
        subtitle="Track generation performance, user engagement, and sales insights across all your tools."
        breadcrumbs={[
          { label: 'Analytics' }
        ]}
      />
      
      <div className="container mx-auto px-4 py-8">
        <GenerationAnalyticsDashboard />
      </div>
      
      <Footer />
    </AppLayout>
  );
};

export default Analytics;